const ACTIONS = {
  GET_CAMPAIGN: "GetCampaign",
  GET_MEMBERS: "GetMembers",
  GET_ACTIVE_MEMBERS: "GetActiveMembers",
};

export { ACTIONS };
